import React from 'react';
import { Button, Table, InputNumber, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { FG115 } from '../../../services/pwg201Api';

interface Props {
  rows: FG115[];
  isEditing: boolean;
  onChange: (rows: FG115[]) => void;
}

const AllocFeeTab: React.FC<Props> = React.memo(({ rows, isEditing, onChange }) => {
  const addRow = () => {
    onChange([
      ...rows,
      { fg115_01: '', fg115_02: rows.length + 1, fg115_11: '', fg115_12: 0 },
    ]);
  };

  const deleteRow = (idx: number) => onChange(rows.filter((_, i) => i !== idx));

  const updateRow = (idx: number, field: keyof FG115, value: any) => {
    const updated = [...rows];
    (updated[idx] as any)[field] = value;
    onChange(updated);
  };

  const total = rows.reduce((sum, r) => sum + (r.fg115_12 || 0), 0);

  const columns: ColumnsType<FG115> = [
    { title: <span data-contract-field="fg115_02">序</span>, dataIndex: 'fg115_02', width: 50 },
    {
      title: <span data-contract-field="fg115_11">交運單號</span>,
      dataIndex: 'fg115_11',
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} onChange={e => updateRow(i, 'fg115_11', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg115_12">分攤金額</span>,
      dataIndex: 'fg115_12',
      width: 120,
      render: (v, _, i) =>
        isEditing ? (
          <InputNumber size="small" value={v} style={{ width: '100%' }} onChange={val => updateRow(i, 'fg115_12', val ?? 0)} />
        ) : v,
    },
    ...(isEditing
      ? [{
          title: '',
          width: 40,
          render: (_: any, __: FG115, i: number) => (
            <Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteRow(i)} />
          ),
        }]
      : []),
  ];

  return (
    <div>
      <Table
        size="small"
        columns={columns}
        dataSource={rows}
        rowKey={(_, i) => `fee-${i}`}
        pagination={false}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={2}>合計</Table.Summary.Cell>
            <Table.Summary.Cell index={1}>{total.toFixed(2)}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      {isEditing && (
        <Button icon={<PlusOutlined />} onClick={addRow} style={{ marginTop: 8 }}>
          新增分攤費用
        </Button>
      )}
    </div>
  );
});

export default AllocFeeTab;
